import { getPath } from '@nordvpn/teams.core/lib/tools/url';
import { ORGANIZATIONS_MEMBERS_PATH } from '../organizations/constants';
export var MEMBERS_LIST_PATH = '/members/';
var MEMBERS_VIEW_PATH = "".concat(MEMBERS_LIST_PATH, ":id/");
export var getMembersViewLink = function getMembersViewLink(identifier) {
    return getPath({
        id: identifier
    }, ORGANIZATIONS_MEMBERS_PATH);
};
export var getMemberViewLink = function getMemberViewLink(identifier) {
    return getPath({
        id: identifier
    }, MEMBERS_VIEW_PATH);
};
